"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebViewPlatform = exports.getCurrentPlatform = exports.getCurrentMobile = exports.Platform = exports.MessagesType = exports.CameraAccessStatus = exports.MobileConnector = exports.HybridFlowIds = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "Platform", { enumerable: true, get: function () { return web_ui_framework_1.Platform; } });
const mock_1 = require("./mock");
var idFlows_1 = require("./idFlows");
Object.defineProperty(exports, "HybridFlowIds", { enumerable: true, get: function () { return idFlows_1.HybridFlowIds; } });
__exportStar(require("./initialization"), exports);
var mobileConnector_1 = require("./mobileConnector");
Object.defineProperty(exports, "MobileConnector", { enumerable: true, get: function () { return mobileConnector_1.MobileConnector; } });
const isWebViewPlatform = () => (0, web_ui_framework_1.isWebViewPlatform)() || (0, mock_1.isMobileCommunicatorMockMode)();
exports.isWebViewPlatform = isWebViewPlatform;
const getCurrentPlatform = () => (isWebViewPlatform() ? web_ui_framework_1.Platform.HYBRID : web_ui_framework_1.Platform.WEB);
exports.getCurrentPlatform = getCurrentPlatform;
const getCurrentMobile = () => (0, web_ui_framework_1.getBrowserPlatform)();
exports.getCurrentMobile = getCurrentMobile;
var types_1 = require("./types");
Object.defineProperty(exports, "CameraAccessStatus", { enumerable: true, get: function () { return types_1.CameraAccessStatus; } });
Object.defineProperty(exports, "MessagesType", { enumerable: true, get: function () { return types_1.MessagesType; } });
//# sourceMappingURL=index.js.map